import { CountryRef } from "../../../../../models/countries/country-ref";

export const uniqueCountries = (countries: (CountryRef | null)[]): CountryRef[] => {
  if (!countries.length) return [];

  const countriesIds: string[] = [];
  const countriesRes: Record<string, CountryRef> = {};

  countries.forEach((country) => {
    if (country?.id) {
      const isCountryAlreadyStored = countriesRes[country.id];

      if (!isCountryAlreadyStored) {
        countriesRes[country.id] = country;

        countriesIds.push(country.id);
      }
    }
  });

  return countriesIds.map((id) => countriesRes[id]);
};
